import React from 'react';
import { ReactComponent as AskEliImage } from 'assets/svg/AskEli.svg';

function AskEliButton({size}) {

	return (
		<div>
			<AskEliImage style={{ 
				height: 'auto', 
				width: `${
					size === "small"
						? "64px"
						: size === "large" 
						? "140px"
						: "100px"
        			}`
				}}
			/>
		</div>
	);
}

export default AskEliButton;
